import { css } from '@emotion/react'
import styled from '@emotion/styled'

interface ListItemContainerProps {
  $isMobile?: boolean
}

const ListItemContainer = styled.div<ListItemContainerProps>`
  ${({ theme }) => css`
    display: flex;
    margin-top: ${theme.spacing(2)}px;
  `}
`

interface RankingUserDataContainerProps {
  $isMobile?: boolean
}

const RankingUserDataContainer = styled.div<RankingUserDataContainerProps>`
  ${({ theme, $isMobile }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: ${theme.spacing(3)}px ${theme.spacing(1)}px;
    border: ${theme.palette.border.borderLineWidth} solid ${theme.palette.border.light};
    border-radius: ${theme.palette.border.borderRadius};
    ${$isMobile && css`
      flex-direction: column;
      padding: ${theme.spacing(2)}px 0px;
    `}
  `}
`

export {
  ListItemContainer,
  RankingUserDataContainer
}
